import { useEffect, useState, useMemo } from "react";
import { useAppSelector } from "../../../store";
import { storedLocale } from "../../Authentication/util";
import { useGetBirthdaysQuery } from "../../../services/ActionReports/ActionReportAPI";
import type { BirthdayActionReportResponse } from "../../../services/ActionReports/ActionReportAPI.types";
import { getBusinessNatures } from "../utils/businessNature";
import { useWatchlistFetch } from "../hooks/useWatchlistFetch";

export const defaultBirthdaysActionReportData = (): BirthdayActionReportResponse => {
  return {
    reportRecords: {
      currentMonth: [],
      nextMonth: [],
      nextTwoMonths: [],
    },
  };
};

export const FetchBirthdaysActionReportData = (period: string) => {
  const { user, configuration } = useAppSelector((state) => state.boot);
  const { actionReports } = configuration;

  const businessNature = useMemo(
    () => getBusinessNatures(user.aff, actionReports?.disableCustomerMembers ?? false),
    [user.aff, actionReports?.disableCustomerMembers],
  );

  const {
    data: payloadData,
    isFetching,
    isError,
  } = useGetBirthdaysQuery({
    Aff: user.aff,
    Abo: user.abo,
    Period: period,
    Locale: storedLocale(),
    BusinessNature: businessNature,
  });

  const { isLoading: isLoadingWatchlist } = useWatchlistFetch();

  const [isLoading, setIsLoading] = useState(true);
  const [errorStatus, setErrorStatus] = useState(false);
  const [birthdaysActionReportData, setBirthdaysActionReportData] = useState<BirthdayActionReportResponse>(
    defaultBirthdaysActionReportData(),
  );

  useEffect(() => {
    // Only stop loading when both report data AND watchlist are ready
    setIsLoading(isFetching || isLoadingWatchlist);
    setErrorStatus(isError);

    if (!isFetching && !isError && payloadData) {
      setBirthdaysActionReportData(payloadData);
    }
  }, [isFetching, period, isError, payloadData, isLoadingWatchlist]);

  return { isLoading, birthdaysActionReportData, errorStatus };
};
